import moment from "moment";
import Constants from "../../constants/Common";

interface IChange {
  value: any;
  overridenValue: any;
}
function instanceOfIChange(object: any): object is IChange {
  return "overridenValue" in object;
}

interface IChangeData {
  entityId: number;
  modifiedBy?: string;
  modifiedById?: number;
  modifiedDateTime: Date;
  model: Record<string, IChange>;
}

const isChanged = (value, newValue) => {
  const isValueEmpty = !value || (Array.isArray(value) && !value.length);
  const isNewValueEmpty =
    !newValue || (Array.isArray(newValue) && !newValue.length);

  if (isValueEmpty && isNewValueEmpty) {
    return false;
  }

  return true;
};

const regExISODate =
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;

const mapIChangeData = (changes, i, change) => {
  Object.entries(change).forEach(([fieldChangedName, change]) => {
    const isIChange = instanceOfIChange(change);
    if (isIChange && isChanged(change.value, change.overridenValue)) {
      changes.push({
        date: moment(i.modifiedDateTime).format(Constants.dateTimeFormat),
        name: fieldChangedName,
        user: i.modifiedBy,
        valueBefore: regExISODate.test(change.value)
          ? moment(change.value).format(Constants.dateFormat)
          : change.value,
        valueAfter: regExISODate.test(change.overridenValue)
          ? moment(change.overridenValue).format(Constants.dateFormat)
          : change.overridenValue,
      });
    }
    if (!isIChange) {
      mapIChangeData(changes, i, change);
    }
  });
};

export const mapHistoryData = (data: Array<IChangeData>) => {
  const changes = [];

  data.forEach((i) => {
    mapIChangeData(changes, i, i.model);
  });

  return changes;
};

export const getComplexName = (item, labels) => {
  const data = labels.reduce((prev, curr) => {
    if (item[curr] !== "undefined") {
      prev.push(item[curr]);
    }
    return prev;
  }, []);

  return data.join(" | ");
};

export const mappingReplaceValue = (
  array: any[],
  objValues: { [key: string]: any },
) => {
  const keys = Object.keys(objValues);
  return array.map((el) => {
    for (const key in el) {
      if (keys.includes(key) && !el[key]) {
        el[key] = objValues[key];
      }
    }
    return el;
  });
};
